import apiClient from "../../common/apiClient";

export const PREMIUM_PLAN_API = "/ijscui/probroker-admin/ceknvuhbd/PremiumPlan/protected";

const authConfig = (token) => (token ? { headers: { Authorization: `Bearer ${token}` } } : {});

// Server clock minus device clock, read the moment a response lands. Countdowns
// add it to Date.now() so a wrong device clock cannot end (or extend) an offer.
export const getClockOffset = (serverTime) => {
  const serverMs = new Date(serverTime).getTime();
  return Number.isFinite(serverMs) ? serverMs - Date.now() : 0;
};

/**
 * Campaigns live right now, highest priority first. Offers are additive, so any
 * failure resolves to "no offers" and the caller renders the normal UI.
 */
export const fetchActiveOffers = async ({ userId, city, token } = {}) => {
  if (!userId && !city) return { offers: [], clockOffsetMs: 0 };

  const response = await apiClient(
    "get",
    userId ? `${PREMIUM_PLAN_API}/offers/active/${userId}` : `${PREMIUM_PLAN_API}/offers/active/`,
    userId ? {} : { city },
    authConfig(token)
  );

  const data = response.success ? response.data?.data : null;
  return {
    offers: Array.isArray(data?.offers) ? data.offers : [],
    clockOffsetMs: getClockOffset(data?.serverTime),
  };
};

/**
 * What a specific purchase would get, for the checkout summary. Returns null on
 * any failure, which the checkout treats the same as "no bonus".
 */
export const fetchOfferQuote = async ({ userId, planId, durationInMonth, promocode, token }) => {
  const response = await apiClient(
    "post",
    `${PREMIUM_PLAN_API}/offers/quote`,
    {
      userId,
      planId,
      durationInMonth,
      ...(promocode ? { promocode } : {}),
    },
    authConfig(token)
  );

  return response.success ? response.data?.data || null : null;
};
